<mat-toolbar *ngIf="itemId != null && !isPreview && !(isPackagingUnit && isGeneric)">
  <div id="menu-row">
    <button mat-button (click)="snav.toggle()" type="button" class="toolbar-text">
      <mat-icon>menu</mat-icon>
      {{ 'sidenav.title' | transloco }}
    </button>
    <div class="wrapped-toolbar-text toolbar-text">
      {{ 'packagingUnit.fields.productName' | transloco }}: {{ getProductNameText() }}
    </div>
    <div class="wrapped-toolbar-text toolbar-text" *ngIf="getArticleNumberText() !== ''; else emptyDiv">
      {{ 'packagingUnit.fields.articleNumber' | transloco }}: {{ getArticleNumberText() }}
    </div>
    <ng-template #emptyDiv>
      <div></div>
    </ng-template>
  </div>
</mat-toolbar>
<mat-divider class="preZero-divider"></mat-divider>

<mat-drawer-container>
  <mat-drawer #snav [mode]="'side'">
    <h3 class="header-margin">{{ 'sidenav.masterData' | transloco }}</h3>
    <mat-nav-list>
      <a mat-list-item *ngIf="!isUserValidator && isWriteAllowed; else viewPackaging" (click)="navigateToItem()">
        <span matLine>{{ (isPackagingUnit ? 'packagingUnit.editPackagingUnit' :
          'packagingSystem.editPackagingSystem') | transloco }}</span>
        <span matLine class="hint">{{ 'home.packagingUnitHome.latestVersion' | transloco }}</span>
      </a>
      <ng-template #viewPackaging>
        <a mat-list-item (click)="navigateToItem()">
          <span matLine>{{ (isPackagingUnit ? 'packagingUnit.viewPackagingUnit' :
            'packagingSystem.viewPackagingSystem') | transloco }}</span>
          <span matLine class="hint">{{ 'home.packagingUnitHome.latestVersion' | transloco }}</span>
        </a>
      </ng-template>
      <a mat-list-item *ngIf="!isCurrentVersion" (click)="navigateToItem(versionId)">
        <span matLine>{{ (isPackagingUnit ? 'packagingUnit.viewPackagingUnit' :
          'packagingSystem.viewPackagingSystem') | transloco }}</span>
        <span matLine class="hint">{{ 'home.packagingUnitHome.historyVersion' | transloco }}</span>
      </a>
      <a mat-list-item (click)="downloadPackagingUnitJson()" *ngIf="isPackagingUnit">
        <span matLine>{{ 'sidenav.downloadPackagingUnitText' | transloco }}</span>
        <span matLine class="hint">{{ 'sidenav.downloadHintJSON' | transloco }}</span>
      </a>
       <a mat-list-item (click)="downloadPackagingSystemsJson()" *ngIf="!isPackagingUnit">
        <span matLine>{{ 'sidenav.downloadPackagingSystemText' | transloco }}</span>
        <span matLine class="hint">{{ 'sidenav.downloadHintJSON' | transloco }}</span>
      </a>
      <a mat-list-item (click)="downloadPackagingUnitExcel()" *ngIf="isPackagingUnit && isExcelDownloadAllowed()" [disabled]="!isValidExcelStructure"
        [matTooltip]="this.getDeactivatedExcelDownloadTooltip()">
        <span matLine>{{ 'sidenav.downloadPackagingUnitText' | transloco }}</span>
        <span matLine class="hint">{{ 'sidenav.downloadPackagingUnitHintEXCEL' | transloco }}</span>
      </a>
      <a mat-list-item  *ngIf="isPackagingUnit && !isExcelDownloadAllowed()"
      href="{{'shop.webshopLink' | transloco }}" target="_blank" [matTooltip]="'dataManagement.directory.toolbar.warnings.noExcelPermissions' | transloco ">
        <span matLine><mat-icon>shopping_cart</mat-icon></span>
        <span matLine>{{ 'sidenav.downloadPackagingUnitText' | transloco }}</span>
        <span matLine class="hint">{{ 'sidenav.downloadPackagingUnitHintEXCEL' | transloco }}</span>
      </a>
    </mat-nav-list>
    <div *ngIf="!isUserValidator">
      <h3 class="header-margin">{{ 'sidenav.evaluations' | transloco }}</h3>
      <mat-nav-list *ngIf="isPackagingUnit; else systemsNavigation">
        <a mat-list-item [matMenuTriggerFor]="analysesUnits.analysesRecyclability"
          (click)="analysesUnits.loadAnalysesForPackagingUnit()">
          {{ 'analysis.recyclabilityAnalysis.title' | transloco }} <mat-icon class="arrow-icon">keyboard_arrow_right
          </mat-icon>
        </a>
        <a mat-list-item [matMenuTriggerFor]="analysesUnits.analysesLca"
          (click)="analysesUnits.loadAnalysesForPackagingUnit()" [disabled]="!isLcaAllowed()"
          [matTooltip]="!isLcaAllowed()? ('warnings.NoPremiumUserAndEnvironmentalEffects' | transloco) : ''"
          matTooltipPosition = "left">
          {{ 'analysis.lifecycleAnalysis.title' | transloco }} <mat-icon class="arrow-icon">keyboard_arrow_right
          </mat-icon>
        </a>
        <a mat-list-item [matMenuTriggerFor]="analysesUnits.analysesExpenseCalculation"
          (click)="analysesUnits.loadAnalysesForPackagingUnit()" [disabled]="!isCCAllowed()"
          [matTooltip]="!isCCAllowed()? ('warnings.OrganizationInsufficientPermissions' | transloco) : ''"
          matTooltipPosition = "left">
          {{ 'analysis.expenseCalculation.title' | transloco }} <mat-icon class="arrow-icon">keyboard_arrow_right
          </mat-icon>
        </a>
      </mat-nav-list>
      <app-analyses-menu-packaging-units #analysesUnits [packagingUnitId]="itemId"
        [packagingUnitType]="callerTypeId" [versionId]="versionId" [isUserValidator]="isUserValidator"
        [caller]="callerPageId" [hasRecyclabilityResult]="hasRecyclabilityResult"
        [hasLifeCycleResult]="hasLifeCycleResult" [creationTimestamp]="creationTimestamp">
      </app-analyses-menu-packaging-units>
      <ng-template #systemsNavigation>
        <mat-nav-list>
          <a mat-list-item [matMenuTriggerFor]="analysesSystems.analysesRecyclability"
            (click)="analysesSystems.loadAnalysesForPackagingSystem()">
            {{ 'analysis.recyclabilityAnalysis.title' | transloco }} <mat-icon class="arrow-icon">keyboard_arrow_right
            </mat-icon>
          </a>
          <a mat-list-item [matMenuTriggerFor]="analysesSystems.analysesLca"
            (click)="analysesSystems.loadAnalysesForPackagingSystem()" [disabled]="!isLcaAllowed()"
            [matTooltip]="!isLcaAllowed()? ('warnings.NoPremiumUserAndEnvironmentalEffects' | transloco) : ''"
            matTooltipPosition = "left">
            {{ 'analysis.lifecycleAnalysis.title' | transloco }} <mat-icon class="arrow-icon">keyboard_arrow_right
            </mat-icon>
          </a>
          <a mat-list-item [matMenuTriggerFor]="analysesSystems.analysesExpenseCalculation"
          (click)="analysesSystems.loadAnalysesForPackagingSystem()" [disabled]="!isCCAllowed()"
          [matTooltip]="!isCCAllowed()? ('warnings.OrganizationInsufficientPermissions' | transloco) : ''"
          matTooltipPosition = "left">
          {{ 'analysis.expenseCalculation.title' | transloco }} <mat-icon class="arrow-icon">keyboard_arrow_right
          </mat-icon>
          </a>
        </mat-nav-list>
      </ng-template>
      <app-analyses-menu-packaging-systems #analysesSystems [packagingSystemId]="itemId" [versionId]="versionId"
        [isUserValidator]="isUserValidator" [caller]="callerPageId" [hasRecyclabilityResult]="hasRecyclabilityResult"
        [hasLifeCycleResult]="hasLifeCycleResult" [creationTimestamp]="creationTimestamp">
      </app-analyses-menu-packaging-systems>
    </div>
    <div *ngIf="!isUserValidator">
      <h3 class="header-margin">{{ 'report.title' | transloco }}</h3>
      <mat-nav-list>
        <a mat-list-item [matMenuTriggerFor]="reports.reportsMenu" (click)="reports.loadReports()">
          {{ 'report.title' | transloco }} <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon>
        </a>
      </mat-nav-list>
      <app-reports-menu-for-packaging-part #reports [callerItemId]="itemId" [callerPage]="callerPageId"
        [callerLevel]="callerLevelId">
      </app-reports-menu-for-packaging-part>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <div>
      <ng-content></ng-content>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
